import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { ASPECT_RATIO } from "@/react/components/constants";
import { CoverImageInput } from "@circle-react-uikit/CoverImageInput";
import { localeRoot } from "../../../../constants";
import { RenderImagePreview } from "./RenderImagePreview";

interface AvatarImageFieldProps {
  signedIdField: string;
  testimonialName: string;
  urlField: string;
}

export const AvatarImageField = ({
  signedIdField,
  urlField,
  testimonialName,
}: AvatarImageFieldProps) => {
  const { setValue } = useFormContext();
  const onDelete = () => {
    setValue(signedIdField, null);
    setValue(urlField, null);
  };

  return (
    <CoverImageInput
      showAddCoverBtn
      changeImageText={t("replace")}
      name={signedIdField}
      hideUnsplash
      hideEmbedUrl
      aspectRatio={ASPECT_RATIO.PAYWALL_AVATAR_IMAGE}
      renderer={props => (
        <RenderImagePreview
          {...props}
          testimonialName={testimonialName || t("random")}
        />
      )}
      onDelete={onDelete}
      title={t([localeRoot, "builder.testimonials.fields.avatar_image_title"])}
      customAspectRatioHelpText={t([
        localeRoot,
        "builder.testimonials.fields.avatar_image_recomendation_size",
      ])}
    />
  );
};
